"use client";

import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/axios";
import type { ProductRow } from "@/lib/types/product";
import { useAuthStore } from "@/stores/authStore";

export type ProductListParams = {
  page: number;
  per_page: number;
  search?: string;
  category_id?: number;
  brand?: string;
  branch_id?: number;
  stock_status?: "all" | "low" | "ok";
  /** Admin catalog: include inactive (POS still uses default active-only). */
  include_inactive?: boolean;
  /** When false, query does not run (e.g. wait for branch). Default true. */
  enabled?: boolean;
};

export function useProducts(params: ProductListParams) {
  const token = useAuthStore((s) => s.accessToken);

  return useQuery({
    queryKey: ["products", params],
    queryFn: async () => {
      const { data } = await api.get<{
        data: ProductRow[];
        pagination: {
          total: number;
          page: number;
          per_page: number;
          last_page: number;
        };
      }>("/api/products", {
        params: {
          page: params.page,
          per_page: params.per_page,
          search: params.search || undefined,
          category_id: params.category_id || undefined,
          brand: params.brand || undefined,
          branch_id: params.branch_id || undefined,
          stock_status:
            params.stock_status && params.stock_status !== "all"
              ? params.stock_status
              : undefined,
          include_inactive: params.include_inactive ? 1 : undefined,
        },
      });

      return data;
    },
    enabled: Boolean(token) && params.enabled !== false,
  });
}
